import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById, updateUser } from "../../app/services/OutletUserService";
import { fetchOrganisation, Organisation } from "../../app/services/OrganisationService";
import { toast } from "react-toastify";

const UpdateUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  

  const [organisationList, setOrganisationList] = useState<Organisation[]>([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState("");


   useEffect(() => {
      const loadOrganisation = async () => {
        try {
          const res = await fetchOrganisation();
          if (res.status === "success") {
            setOrganisationList(res.data); 
          }
        } catch (err) {
          toast("Failed to load organisation");
        }
      };
    
      loadOrganisation();
    }, []);

  

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (!id) return;
        const res = await getUserById(Number(id));
        if (res.status === "success") {
          const data = res.data;
          setName(data[0]?.user.name);
          setEmail(data[0]?.user.email);
          setSelectedOrganisation(data[0]?.org_id);
          toast.success(res.message);
          
        }
      } catch (error) {
        toast("Failed to fetch User");
      }
    };

    fetchUserData();
  }, [id]);

  

  const handleSubmit = async () => {
    const payload = {
      name,
      user_id:Number(id)
      
    };

    try {
      const response = await updateUser(payload, Number(id));
      if (response.status === "success") {
        toast("User updated successfully!");
        navigate("/organisation/outlet/user");
      } else {
        toast(response.data.message);
      }
    } catch (error) {
      toast("Failed to update user.");
    }
  };

  return (
    <Box minHeight="20vh" display="flex" justifyContent="center" alignItems="center" bgcolor="#f9f9f9">
      <Paper elevation={3} sx={{ backgroundColor: "#fff", borderRadius: 4, p: 5, width: "100%", maxWidth: 900 }}>
        <Typography variant="h5" fontWeight={700} mb={4} color="primary" textAlign="center">
          Update User
        </Typography>
        <Box mb={3}>
                  <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
                    Organisation <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    disabled
                    fullWidth
                    displayEmpty
                    value={selectedOrganisation}
                    onChange={(e) => setSelectedOrganisation(e.target.value)}
                  >
                    <MenuItem value="" disabled>Select a organisation</MenuItem>
                    {organisationList.map((org) => (
                      <MenuItem key={org.id} value={org.id}>
                        {org.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
        <Box mb={3}><InputLabel>Email</InputLabel><TextField disabled fullWidth value={email} onChange={(e) => setEmail(e.target.value)} /></Box>
        
        <Box mb={3}><InputLabel>Name</InputLabel><TextField fullWidth value={name} onChange={(e) => setName(e.target.value)} /></Box>
        
        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="contained" onClick={handleSubmit} sx={{ px: 4, py: 1.2, backgroundColor: "#fcb500", color: "#000", fontWeight: 600, "&:hover": { backgroundColor: "#fbc02d" } }}>
            Update
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UpdateUser;
